'use client'

import { useEffect } from 'react'

const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'fbclid',
  'gclid',
  '_gclid',
  'msclkid',
  'ttclid',
  'twclid',
  'li_fat_id',
  'mc_eid',
  '_hsenc',
  '_hsmi',
  '_gl',
  '_ga',
  '_gid',
]

// Params matched by prefix (e.g. _ga_G-XXXXXXX, _gac_UA-XXXXX)
const TRACKING_PARAM_PREFIXES = ['_ga_', '_gac_']

const SESSION_KEY = 'tracking_params'

export function getStoredTrackingParams(): Record<string, string> {
  if (typeof window === 'undefined') return {}
  try {
    return JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}')
  } catch {
    return {}
  }
}

export function useCleanTrackingParams() {
  useEffect(() => {
    const url = new URL(window.location.href)
    const params = url.searchParams

    const captured: Record<string, string> = {}
    let hasTracking = false

    for (const key of TRACKING_PARAMS) {
      const value = params.get(key)
      if (value) {
        captured[key] = value
        params.delete(key)
        hasTracking = true
      }
    }

    const prefixedKeys = [...params.keys()].filter((key) =>
      TRACKING_PARAM_PREFIXES.some((prefix) => key.startsWith(prefix))
    )
    for (const key of prefixedKeys) {
      captured[key] = params.get(key)!
      params.delete(key)
      hasTracking = true
    }

    if (!hasTracking) return

    try {
      const existing = getStoredTrackingParams()
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ...existing, ...captured }))
    } catch {}

    window.history.replaceState(null, '', url.toString())
  }, [])
}
